<template>
  <van-popup v-model="popShow" position="bottom" :close-on-click-overlay="true">
    <div class="quick_login_popup">
      <div class="title">{{ $t('account.quickLoginTitle') }}</div>
      <div v-for="(item, index) in quickLoginAuthList" :key="index" class="option">
        <div class="content">
          <div class="option_title">{{ item.merchantName }}</div>
          <div class="option_desc" v-if="item.merchantName === 'Chamet'">Chamet/MateMet/ChillChat</div>
        </div>
        <van-switch active-color="#378E5B" :value="true" @input="() => cancelQuickLogin(item.merchantType)" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'HomeQuickLoginPopup',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    quickLoginAuthList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popShow: false
    }
  },
  watch: {
    value(val) {
      this.popShow = val
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    cancelQuickLogin(merchantType) {
      this.$emit('cancelQuickLogin', merchantType)
    }
  }
}
</script>

<style scoped>
.quick_login_popup {
  box-sizing: border-box;
  padding: 0.12rem 0;
  border-radius: 0.18rem 0.18rem 0 0;
  background: #fff;
}

.title {
  width: 100%;
  display: flex;
  height: 0.6rem;
  padding: 0rem 0.24rem;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
}

.option {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  display: flex;
  height: 0.6rem;
  padding: 0rem 0.24rem;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.option .content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.option_title {
  color: #443956;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.option_desc {
  color: #a19caa;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.option:nth-child(n + 3) {
  border-top: 1px solid #eeeef7;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeQuickLoginPopup.vue